module.exports = __webpack_public_path__ + "static/media/mhlogo-light.b3dcfe5f.svg";